import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'cx_foundations-answer_page-view';

/**
 * Event that tracks when user views the "Answer" page
 */
export function trackCxFoundationsAnswerPageView(
  Retailerbrand_token: string,
  issueTree2: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { Retailerbrand_token, issueTree2 },
  });
}
